// @core/index.ts
// Auto-generated by corebuilder. DO NOT EDIT.

// API client and endpoints
export * from './api';

// State stores
export * from './stores';

// TypeScript types
export * from './types';

// Design system tokens
export * from './ui';

// Re-export rootStore initialization
import { rootStore } from './stores';

export interface CoreConfig {
  apiBaseUrl: string;
  defaultLocale?: string;
  themeColors?: import('./stores/theme').ThemeConfig;
  scope?: { platformId?: string; productId?: string; tenantId?: string };
}

/**
 * Initialize the core package.
 * This should be called once at application startup.
 *
 * @example
 * ```typescript
 * import { initializeCore } from '@core';
 *
 * await initializeCore({
 *   apiBaseUrl: '/api/v1',
 *   defaultLocale: 'en',
 * });
 * ```
 */
export async function initializeCore(config: CoreConfig): Promise<void> {
  await rootStore.initialize(config);
}

/**
 * Cleanup the core package.
 * Call this when unmounting the application.
 */
export function disposeCore(): void {
  rootStore.dispose();
}
